/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["ig",[["A.M.","P.M."],u,["N’ụtụtụ","N’abali"]],[["A.M.","P.M."],u,u],[["S","M","T","W","T","F","S"],["Sọn","Mọn","Tiu","Wen","Tọọ","Fraị","Sat"],["Sọndee","Mọnde","Tiuzdee","Wenezdee","Tọọzdee","Fraịdee","Satọdee"],["Sọn","Mọn","Tiu","Wen","Tọọ","Fraị","Sat"]],u,[["J","F","M","E","M","J","J","Ọ","S","Ọ","N","D"],["Jen","Feb","Maa","Epr","Mee","Juu","Jul","Ọgọ","Sep","Ọkt","Nov","Dis"],["Jenụwarị","Febrụwarị","Maachị","Epreel","Mee","Juun","Julaị","Ọgọọst","Septemba","Ọktoba","Novemba","Disemba"]],u,[["T.K.","A.K."],u,["Tupu Kraist","Afọ Kraịst"]],1,[6,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,"{1} 'na' {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"NGN","₦","Naịra",{"NGN":["₦"]},"ltr", plural];
